import { DEFAULT_NETWORK } from './store/modules/network/network'

const DCM_FAUCET_ID = DEFAULT_NETWORK.dcommFaucetUrl

interface AddressDict {
    [key: string]: string
}

const dict: AddressDict = {}

dict[DCM_FAUCET_ID] = 'The DCM Faucet'

export default dict
